import React from "react";
import 'animate.css';
const What_Sets_Apart = () =>

{
    return(
        
<>
<article>
        <div className="container ">
            <div className="row">
                <div className="col">
                    <div className="title-section">
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-5 text-center">
                    <div className="sidebar-section show-bg-image">
                        <div className="sidebar-item sticky-top">
                            <div className="sidebar-content">
                                <img src="../assets/img/logo.png" className="img-fluid py-sec" />
                                <div className="service-title">
                                <h1 className="pt-lg-5"><span className="sub-color">Our </span> Stand Out Qualities</h1>                                                    
                                </div>                              
                                <p className="text-justify short-desc">BFC Softtech is committed to helping businesses of all sizes succeed through the use of cutting-edge technology and innovative approaches. Read on to figure out what sets us apart from the competition.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-7">
                    <div className="content-section">
                        <div className="service-section hover-icon">
                            <h3>01</h3>
                            <div className="service-card">
                                <div className="service-img d-flex">
                                    <img src="../assets/img/service/retention .png" className="img-fluid hy" alt="" />
                                    <h2 className="pt-2 pl-3">Client Retention</h2>
                                </div>
                                <div className="service-info">                                   
                                    <p>Our dedication to providing top-notch services has kept our clients coming back for more. Trust BFC Softtech to deliver exceptional results for your business.</p>
                                    {/* <a href="about.html" className="default-btn-one">Read More</a> */}
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="hover-icon">
                        <div className="row justify-content-end ">
                            <div className="col-md-12">
                                <h3>02</h3>
                            </div>
                        </div>
                        <div className="row pb-50 ">
                            <div className="col-md-12">
                                <div className="service-card">
                                    <div className="service-img d-flex">
                                        <img src="../assets/img/service/money.png" className="img-fluid" alt="" />
                                        <h2 className="pt-2 pl-3">Wealth of Experience</h2>
                                    </div>
                                    <div className="service-info">
                                       
                                        <p>With a track record of delivering successful projects across domains, BFC Softtech is your go-to technology partner. Trust us to bring our expertise to your project.</p>
                                        {/* <a href="about.html" className="default-btn-one">Read More</a> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                        <hr />
                        <div className="hover-icon">
                        <div className="row justify-content-end">
                            <div className="col-md-12">
                                <h3>03</h3>
                            </div>
                        </div>
                        <div className="row pb-50 ">
                            <div className="col-md-12">
                                <div className="service-card">
                                    <div className="service-img d-flex">
                                        <img src="../assets/img/service/support.png" className="img-fluid" alt="" />
                                        <h2 className="pt-2 pl-3">Guaranteed Customer Satisfaction</h2>
                                    </div>
                                    <div className="service-info">
                                      
                                        <p>We are dedicated to delivering exceptional solutions and services that exceed our customers' expectations. Choose BFC Softtech for a partnership that puts your satisfaction first.</p>
                                        {/* <a href="about.html" className="default-btn-one">Read More</a> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                        <hr />
                        <div className="hover-icon">
                        <div className="row justify-content-end">
                            <div className="col-md-12">
                                <h3>04</h3>
                            </div>
                        </div>
                        <div className="row pb-50 ">
                            <div className="col-md-12">
                                <div className="service-card">
                                    <div className="service-img d-flex">
                                        <img src="../assets/img/service/24-hours.png" className="img-fluid" alt="" />
                                        <h2 className="pt-2 pl-3">24/7 Customer Support</h2>
                                    </div>
                                    <div className="service-info">
                                   
                                        <p>We offer 24/7 customer service, ensuring that you always have someone to turn to for assistance. Choose us as your technology partner, and rest easy knowing that we have you covered around the clock.</p>
                                      
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                        <hr />
                        <div className="hover-icon">
                        <div className="row justify-content-end">
                            <div className="col-md-12">
                                <h3>05</h3>
                            </div>
                        </div>
                        <div className="row pb-50 ">
                            <div className="col-md-12">
                                <div className="service-card">
                                    <div className="service-img d-flex">
                                        <img src="../assets/img/service/success.png" className="img-fluid" alt="" />
                                        <h2 className="pt-2 pl-3">Exceptional Success Rate</h2>
                                    </div>
                                    <div className="service-info">
                                    
                                        <p>Looking for a technology partner with a proven track record of success? BFC Softtech has a long history of delivering exceptional results. Trust us to take your business to the next level.</p>
                                      
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                        <hr />
                       
                        
                    </div>
                </div>
            </div>
        </div>
    </article>

</>

    )
}
export default What_Sets_Apart